import { attributeTypeCodes } from "@/enums/customAttributeTypeCodes";

export const cleanHtmlAttributes = (attributes) => {
  if (!attributes) return [];

  const richTextAttributes = attributes.filter(
    attr => attr.attributeTypeCode === attributeTypeCodes.T_RICH
  );

  richTextAttributes.forEach(attr => {
    if (attr.value) {
      attr.value = cleanHtmlText(attr.value)
    }
  });

  return attributes;
};


export const cleanHtmlText = (text) => {
  if (!text) return "";

  let cleanText = text.replace(/<[^>]*>/g, '');

  cleanText = cleanText.replace(/&nbsp;/g, ' ');

  cleanText = cleanText.replace(/\s+/g, ' ').trim();

  return cleanText;
};
